import React from 'react';
import {Field} from 'formik';

export const TextField = ({
    type='text',
    name,
    value,
    error,
    isDisabled,
    handleChange,
    placeholder,
    component,
    options,
})=> {
    return (
        <label className={["auth-label", error ? 'error' : '', isDisabled ? 'is_disabled' : ''].join(' ')}>
            <Field
                className={[!!value?.length ? 'is_valid' : ''].join(' ')}
                onChange={handleChange}
                value={value}
                id={name}
                name={name}
                type={type}
                component={component}
                options={options}
                disabled={isDisabled}
            />
            <span className={['auth-label-placeholder', !!value?.length ? 'is_valid' : ''].join(' ')}>{placeholder}</span>
            <span className="authorization__error">
               {error}
            </span>
        </label>
    )
}
